(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fk-header"]) return;
  try {
    
  document.querySelectorAll('.fk-header').forEach(function (header) {
    if (header.classList.contains('fk-header--transparent-home')) {
      var scrollContainer = document.querySelector('.page-wrapper');
      var updateHeaderBackground = function () {
        var scrollTop = scrollContainer ? scrollContainer.scrollTop : window.scrollY;
        var viewportHeight = scrollContainer ? scrollContainer.clientHeight : window.innerHeight;
        header.classList.toggle('is-pinned', scrollTop > 0);
        header.classList.toggle('is-scrolled', scrollTop >= viewportHeight * 0.8);
      };

      updateHeaderBackground();
      (scrollContainer || window).addEventListener('scroll', updateHeaderBackground, { passive: true });
      window.addEventListener('resize', updateHeaderBackground);
    }

    var drawer = header.querySelector('[data-fk-drawer]');
    var toggle = header.querySelector('[data-fk-menu-toggle]');
    var close = header.querySelector('[data-fk-menu-close]');
    if (!drawer || !toggle) return;

    function open() {
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function shut() {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);

    // Bấm ra ngoài panel thì đóng
    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) shut();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) shut();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-home-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fk-home-faq]').forEach(function (faq) {
    faq.querySelectorAll('details').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        faq.querySelectorAll('details[open]').forEach(function (openItem) {
          if (openItem !== item) openItem.removeAttribute('open');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-main-collection"]) return;
  try {
    
  (function () {
    var form = document.getElementById('fk-facet-form');
    var sidebar = document.getElementById('fk-filters');

    // Mở / đóng panel lọc trên mobile
    var openBtn = document.querySelector('[data-fk-filter-open]');
    var closeBtn = document.querySelector('[data-fk-filter-close]');

    if (openBtn && sidebar) {
      openBtn.addEventListener('click', function () {
        sidebar.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }

    if (closeBtn && sidebar) {
      closeBtn.addEventListener('click', function () {
        sidebar.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    // "+ Show more": hiện nốt các mục đang ẩn
    document.querySelectorAll('[data-fk-more]').forEach(function (button) {
      button.addEventListener('click', function () {
        var body = button.parentElement;
        if (!body) return;
        body.querySelectorAll('.fk-facet__extra').forEach(function (item) {
          item.hidden = false;
        });
        button.remove();
      });
    });

    // Thanh trượt giá
    document.querySelectorAll('[data-fk-range]').forEach(function (range) {
      var min = range.querySelector('[data-fk-range-min]');
      var max = range.querySelector('[data-fk-range-max]');
      var fill = range.querySelector('[data-fk-range-fill]');
      var hiddenMin = range.querySelector('[data-fk-range-input-min]');
      var hiddenMax = range.querySelector('[data-fk-range-input-max]');
      if (!min || !max) return;

      var ceiling = parseFloat(range.getAttribute('data-max')) || 0;
      var symbol = range.getAttribute('data-currency') || '$';
      var labelMin = range.parentElement.querySelector('[data-fk-range-label-min]');
      var labelMax = range.parentElement.querySelector('[data-fk-range-label-max]');

      function money(value) {
        return symbol + Number(value).toFixed(2);
      }

      function paint() {
        var lo = Math.min(Number(min.value), Number(max.value));
        var hi = Math.max(Number(min.value), Number(max.value));
        if (fill && ceiling > 0) {
          fill.style.left = (lo / ceiling) * 100 + '%';
          fill.style.width = ((hi - lo) / ceiling) * 100 + '%';
        }
        if (labelMin) labelMin.textContent = 'Min:' + money(lo);
        if (labelMax) labelMax.textContent = 'Max:' + money(hi);
        // Chỉ gửi tham số khi người dùng thực sự thu hẹp khoảng giá
        if (hiddenMin) hiddenMin.value = lo > 0 ? lo : '';
        if (hiddenMax) hiddenMax.value = hi < ceiling ? hi : '';
      }

      // Không cho hai nút kéo vượt qua nhau
      min.addEventListener('input', function () {
        if (Number(min.value) > Number(max.value)) min.value = max.value;
        paint();
      });
      max.addEventListener('input', function () {
        if (Number(max.value) < Number(min.value)) max.value = min.value;
        paint();
      });

      min.addEventListener('change', submitFacets);
      max.addEventListener('change', submitFacets);

      paint();
    });

    // Đổi bộ lọc thì nạp lại trang với tham số tương ứng
    function submitFacets() {
      if (!form) return;
      var params = new URLSearchParams();
      form.querySelectorAll('input, select').forEach(function (el) {
        if (!el.name) return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        if (el.value === '') return;
        params.append(el.name, el.value);
      });
      var query = params.toString();
      window.location.search = query ? '?' + query : '';
    }

    if (form) {
      form.addEventListener('change', function (event) {
        if (event.target.type === 'number') return;
        submitFacets();
      });

      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.addEventListener('change', submitFacets);
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitFacets();
      });
    }

    // Sắp xếp
    var sort = document.querySelector('[data-fk-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', sort.value);
        params.delete('page');
        window.location.search = params.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-main-product"]) return;
  try {
    
  document.querySelectorAll('.fk-pdp').forEach(function (root) {
    /* ---------------- Gallery ---------------- */
    var thumbs = root.querySelectorAll('[data-fk-thumb]');
    var slides = root.querySelectorAll('[data-fk-slide]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-fk-thumb');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        slides.forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-fk-slide') === index);
        });
      });
    });

    /* ------------- Tab / accordion ------------- */
    var tabs = root.querySelectorAll('[data-fk-tab]');
    var panels = root.querySelectorAll('[data-fk-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-fk-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-fk-panel') === index);
        });
      });
    });

    root.querySelectorAll('[data-fk-head]').forEach(function (head) {
      head.addEventListener('click', function () {
        var open = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    /* --------------- Biến thể ---------------- */
    var dataEl = document.querySelector('[data-fk-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-fk-variant-id]');
    var priceEl = root.querySelector('[data-fk-price]');
    var compareEl = root.querySelector('[data-fk-compare]');
    var savedEl = root.querySelector('[data-fk-saved]');
    var atc = root.querySelector('[data-fk-atc]');
    var optionGroups = root.querySelectorAll('[data-fk-option-index]');

    function money(cents) {
      var value = (cents / 100);
      var text = value % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
      return '$' + text;
    }

    function selectedOptions() {
      var values = [];
      optionGroups.forEach(function (group) {
        var checked = group.querySelector('[data-fk-option-input]:checked');
        values.push(checked ? checked.value : null);
        var label = group.querySelector('[data-fk-option-value]');
        if (label && checked) label.textContent = checked.value;
      });
      return values;
    }

    function update() {
      var chosen = selectedOptions();
      var match = variants.find(function (v) {
        return chosen.every(function (value, i) { return value === null || v.options[i] === value; });
      });
      if (!match) return;

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);

      var onSale = match.compare_at_price && match.compare_at_price > match.price;
      if (compareEl) {
        compareEl.textContent = onSale ? money(match.compare_at_price) : '';
        compareEl.style.display = onSale ? '' : 'none';
      }
      if (savedEl) {
        savedEl.style.display = onSale ? '' : 'none';
        if (onSale) {
          var pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
          savedEl.textContent = 'Save ' + pct + '%';
        }
      }
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? atc.getAttribute('data-label') || atc.textContent : 'Sold out';
      }

      // Nhảy tới ảnh của biến thể nếu có
      if (match.featured_media) {
        var target = root.querySelector('[data-fk-thumb="' + match.featured_media.position + '"]');
        if (target) target.click();
      }
    }

    if (atc) atc.setAttribute('data-label', atc.textContent.trim());
    root.querySelectorAll('[data-fk-option-input]').forEach(function (input) {
      input.addEventListener('change', update);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-neon-designer"]) return;
  try {
    
  document.querySelectorAll('.fk-nd').forEach(function (root) {
    var form = root.querySelector('#fk-nd-form');
    var preview = root.querySelector('[data-fk-nd-preview]');
    var canvas = root.querySelector('[data-fk-nd-canvas]');
    var scene = root.querySelector('[data-fk-nd-scene]');
    var textarea = root.querySelector('[data-fk-nd-text]');
    var variantInput = root.querySelector('[data-fk-nd-variant]');
    var submit = root.querySelector('[data-fk-nd-submit]');
    if (!form || !preview) return;

    var placeholder = preview.textContent;
    var activeTab = 'text';
    var zoom = 1;

    function money(cents) {
      var v = Number(cents) / 100;
      return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
    }

    /* ---------------- Giá theo kích thước ---------------- */

    function applySize() {
      var checked = root.querySelector('.fk-nd__size-radio:checked');
      if (!checked) return;

      if (variantInput) variantInput.value = checked.value;

      root.querySelectorAll('[data-fk-nd-price]').forEach(function (el) {
        el.textContent = money(checked.getAttribute('data-price'));
      });

      var compare = Number(checked.getAttribute('data-compare'));
      var price = Number(checked.getAttribute('data-price'));
      root.querySelectorAll('[data-fk-nd-compare]').forEach(function (el) {
        el.textContent = compare > price ? money(compare) : '';
      });

      // Thước đo lấy đúng con số trong tên biến thể, ví dụ "50cm | 20in"
      var label = checked.getAttribute('data-label') || '';
      var widthEl = root.querySelector('[data-fk-nd-width]');
      var heightEl = root.querySelector('[data-fk-nd-height]');
      if (widthEl) widthEl.textContent = label.replace(/\s*\|\s*/, ' / ');

      var cm = parseInt(label, 10);
      if (heightEl && cm) {
        var lines = (textarea && textarea.value ? textarea.value : placeholder).split('\n').length;
        var h = Math.round(cm * (lines > 1 ? 0.5 : 0.28));
        heightEl.textContent = h + 'cm\n' + Math.round(h / 2.54) + 'in';
      }
    }

    root.querySelectorAll('.fk-nd__size-radio').forEach(function (radio) {
      radio.addEventListener('change', applySize);
    });

    /* ---------------- Chữ xem trước ---------------- */

    function applyText() {
      if (!textarea) return;
      var maxLines = parseInt(textarea.getAttribute('data-max-lines'), 10) || 2;
      var maxChars = parseInt(textarea.getAttribute('data-max-chars'), 10) || 10;

      // Cắt theo đúng giới hạn số dòng và số ký tự mỗi dòng
      var lines = textarea.value.split('\n').slice(0, maxLines).map(function (line) {
        return line.slice(0, maxChars);
      });
      var clean = lines.join('\n');
      if (clean !== textarea.value) textarea.value = clean;

      preview.textContent = clean.trim() === '' ? placeholder : clean;
      if (submit) submit.disabled = activeTab === 'text' && clean.trim() === '';
      applySize();
    }

    if (textarea) textarea.addEventListener('input', applyText);

    /* ---------------- Font ---------------- */

    var fontInput = root.querySelector('[data-fk-nd-font-input]');
    var fontName = root.querySelector('[data-fk-nd-font-name]');

    function pickFont(button) {
      root.querySelectorAll('[data-fk-nd-font]').forEach(function (b) {
        b.classList.toggle('is-active', b === button);
      });
      var family = button.getAttribute('data-fk-nd-font');
      preview.style.fontFamily = "'" + family + "', cursive";
      if (fontInput) fontInput.value = button.getAttribute('data-name');
      if (fontName) fontName.textContent = button.getAttribute('data-name');
    }

    root.querySelectorAll('[data-fk-nd-font]').forEach(function (button) {
      button.addEventListener('click', function () { pickFont(button); });
    });

    var fontPick = root.querySelector('[data-fk-nd-fontpick]');
    var fontToggle = root.querySelector('[data-fk-nd-font-toggle]');
    if (fontPick && fontToggle) {
      fontToggle.addEventListener('click', function () {
        var open = fontPick.classList.toggle('is-open');
        fontToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* ---------------- Màu ---------------- */

    var colorInput = root.querySelector('[data-fk-nd-color-input]');
    var colorName = root.querySelector('[data-fk-nd-color-name]');

    function pickColor(button) {
      root.querySelectorAll('[data-fk-nd-color]').forEach(function (b) {
        b.classList.toggle('is-active', b === button);
      });
      var hex = button.getAttribute('data-fk-nd-color');
      preview.style.color = hex;
      preview.style.setProperty('--fk-nd-glow', hex);
      if (colorInput) colorInput.value = button.getAttribute('data-name');
      if (colorName) colorName.textContent = button.getAttribute('data-name');
    }

    root.querySelectorAll('[data-fk-nd-color]').forEach(function (button) {
      button.addEventListener('click', function () { pickColor(button); });
    });

    /* ---------------- Căn lề ---------------- */

    var alignInput = root.querySelector('[data-fk-nd-align-input]');
    root.querySelectorAll('[data-fk-nd-align]').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-fk-nd-align');
        root.querySelectorAll('[data-fk-nd-align]').forEach(function (b) {
          b.classList.toggle('is-active', b === button);
        });
        preview.style.textAlign = value;
        if (alignInput) alignInput.value = value;
      });
    });

    /* ---------------- Tab ---------------- */

    function selectTab(name) {
      activeTab = name;
      root.querySelectorAll('[data-fk-nd-tab]').forEach(function (t) {
        var on = t.getAttribute('data-fk-nd-tab') === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-fk-nd-pane]').forEach(function (pane) {
        pane.classList.toggle('is-active', pane.getAttribute('data-fk-nd-pane') === name);
      });
      if (submit) {
        submit.disabled = name === 'text' && (!textarea || textarea.value.trim() === '');
      }
    }

    root.querySelectorAll('[data-fk-nd-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        selectTab(tab.getAttribute('data-fk-nd-tab'));
      });
    });

    /* ---- Màn chọn trên mobile ---- */

    root.querySelectorAll('[data-fk-nd-choose]').forEach(function (choice) {
      choice.addEventListener('click', function () {
        selectTab(choice.getAttribute('data-fk-nd-choose'));
        root.classList.add('is-ready');
        window.scrollTo({ top: root.offsetTop - 10, behavior: 'smooth' });
      });
    });

    var back = root.querySelector('[data-fk-nd-back]');
    if (back) {
      back.addEventListener('click', function () {
        root.classList.remove('is-ready');
        window.scrollTo({ top: root.offsetTop - 10, behavior: 'smooth' });
      });
    }

    // Desktop bỏ qua màn chọn, vào thẳng công cụ
    function syncViewport() {
      if (window.matchMedia('(min-width: 1000px)').matches) root.classList.add('is-ready');
    }
    syncViewport();
    window.addEventListener('resize', syncViewport);

    /* ---------------- Tải logo ---------------- */

    var file = root.querySelector('[data-fk-nd-file]');
    var filename = root.querySelector('[data-fk-nd-filename]');
    if (file && filename) {
      var original = filename.textContent;
      file.addEventListener('change', function () {
        filename.textContent = file.files && file.files[0] ? file.files[0].name : original;
      });
    }

    /* ---------------- Nền, thu phóng, ánh sáng ---------------- */

    function applyBackground(button) {
      root.querySelectorAll('[data-fk-nd-bg]').forEach(function (b) {
        b.classList.toggle('is-active', b === button);
      });
      var url = button.getAttribute('data-fk-nd-bg');
      canvas.style.backgroundImage = url ? 'url(' + url + ')' : 'none';
      canvas.classList.toggle('has-image', Boolean(url));
    }

    root.querySelectorAll('[data-fk-nd-bg]').forEach(function (button) {
      button.addEventListener('click', function () { applyBackground(button); });
      if (button.classList.contains('is-active')) applyBackground(button);
    });

    root.querySelectorAll('[data-fk-nd-zoom]').forEach(function (button) {
      button.addEventListener('click', function () {
        var mode = button.getAttribute('data-fk-nd-zoom');
        if (mode === 'in') zoom = Math.min(zoom + 0.15, 2);
        else if (mode === 'out') zoom = Math.max(zoom - 0.15, 0.5);
        else zoom = 1;
        scene.style.transform = 'scale(' + zoom + ')';
      });
    });

    var glowBtn = root.querySelector('[data-fk-nd-glow]');
    if (glowBtn) {
      glowBtn.addEventListener('click', function () {
        var on = preview.classList.toggle('has-glow');
        glowBtn.classList.toggle('is-active', on);
      });
    }

    /* ---- Không gửi trường rỗng hoặc trường của tab đang đóng ----
       để đơn hàng chỉ mang đúng thông tin cần cho sản xuất. */
    form.addEventListener('submit', function () {
      var textPane = root.querySelector('[data-fk-nd-pane="text"]');
      var logoPane = root.querySelector('[data-fk-nd-pane="logo"]');
      var inactive = activeTab === 'text' ? logoPane : textPane;

      // Vô hiệu hoá toàn bộ trường của tab không dùng
      if (inactive) {
        inactive.querySelectorAll('input[name], textarea[name], select[name]').forEach(function (el) {
          el.disabled = true;
        });
      }

      // Bỏ những trường còn lại nhưng để trống
      form.querySelectorAll('input[name^="properties"], textarea[name^="properties"]').forEach(function (el) {
        if (el.type === 'file') {
          if (!el.files || el.files.length === 0) el.disabled = true;
        } else if (String(el.value).trim() === '') {
          el.disabled = true;
        }
      });
    });

    /* ---------------- Khởi tạo ---------------- */

    preview.classList.add('has-glow');
    var firstColor = root.querySelector('[data-fk-nd-color]');
    if (firstColor) pickColor(firstColor);
    var firstFont = root.querySelector('[data-fk-nd-font]');
    if (firstFont) pickFont(firstFont);
    applyText();
    applySize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fk-review-wall"] && !Shopify.designMode) return;
  try {
    
  /* ---- Popup xem đánh giá ---- */
  document.querySelectorAll('.fk-rw').forEach(function (root) {
    var modal = root.querySelector('[data-fk-rw-modal]');
    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-fk-rw-open]'));
    if (!modal || !openers.length) return;

    var dialog = modal.querySelector('.fk-rw__dialog');
    var stage = modal.querySelector('[data-fk-rw-stage]');
    var thumbs = modal.querySelector('[data-fk-rw-thumbs]');
    var elAuthor = modal.querySelector('[data-fk-rw-m-author]');
    var elVerified = modal.querySelector('[data-fk-rw-m-verified]');
    var elStars = modal.querySelector('[data-fk-rw-m-stars]');
    var elDate = modal.querySelector('[data-fk-rw-m-date]');
    var elText = modal.querySelector('[data-fk-rw-m-text]');
    var closeBtn = modal.querySelector('.fk-rw__close');
    var current = 0;
    var lastFocus = null;

    var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" ' +
      'd="M12 2l2.9 6.26 6.6.62-4.98 4.42 1.46 6.7L12 16.6 6.02 20l1.46-6.7L2.5 8.88l6.6-.62z"/></svg>';

    /* Dải ảnh nhỏ chỉ gồm các đánh giá có ảnh */
    var withPhoto = openers.filter(function (b) { return b.dataset.full; });
    withPhoto.forEach(function (b, i) {
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'fk-rw__thumb';
      t.innerHTML = '<img src="' + b.dataset.thumb + '" alt="" loading="lazy">';
      t.addEventListener('click', function () { show(openers.indexOf(b)); });
      thumbs.appendChild(t);
    });

    function stars(n) {
      var out = '';
      for (var i = 1; i <= 5; i++) {
        out += STAR.replace('<svg', i > n ? '<svg class="is-empty"' : '<svg');
      }
      return out;
    }

    function show(index) {
      if (index < 0) index = openers.length - 1;
      if (index >= openers.length) index = 0;
      current = index;
      var d = openers[index].dataset;

      stage.innerHTML = d.full ? '<img src="' + d.full + '" alt="">' : '';
      dialog.classList.toggle('is-textonly', !d.full);

      elAuthor.textContent = d.author || '';
      elVerified.hidden = d.verified !== 'true';
      elStars.innerHTML = stars(parseInt(d.rating, 10) || 5);
      elDate.textContent = d.date || '';
      elText.textContent = d.text || '';

      var pos = withPhoto.indexOf(openers[index]);
      thumbs.querySelectorAll('.fk-rw__thumb').forEach(function (t, i) {
        t.classList.toggle('is-active', i === pos);
        if (i === pos) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }

    function open(index) {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      show(index);
      closeBtn.focus();
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      stage.innerHTML = '';
      if (lastFocus) lastFocus.focus();
    }

    openers.forEach(function (b, i) {
      b.addEventListener('click', function () { open(i); });
    });
    modal.querySelectorAll('[data-fk-rw-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    modal.querySelector('[data-fk-rw-prev]').addEventListener('click', function () { show(current - 1); });
    modal.querySelector('[data-fk-rw-next]').addEventListener('click', function () { show(current + 1); });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });
  });

  document.querySelectorAll('[data-fk-rw-more]').forEach(function (button) {
    button.addEventListener('click', function () {
      var section = button.closest('.fk-rw');
      var hidden = section.querySelectorAll('.fk-rw__card.is-hidden');
      // Mỗi lần bấm mở thêm đúng bằng số thẻ hiện sẵn lúc đầu
      var step = parseInt(button.getAttribute('data-step'), 10) ||
        section.querySelectorAll('.fk-rw__card:not(.is-hidden)').length || 12;
      button.setAttribute('data-step', step);
      Array.prototype.slice.call(hidden, 0, step).forEach(function (card) {
        card.classList.remove('is-hidden');
      });
      if (section.querySelectorAll('.fk-rw__card.is-hidden').length === 0) {
        button.parentElement.remove();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
